import { useInsightAudioPlayer } from "../hook/useInsightAudioPlayer";

import { IconButton } from "@mui/material";
import PauseAudioIcon from "../../../../../icons/PauseAudioIcon";
import PlayAudioIcon from "../../../../../icons/PlayAudioIcon";

const AudioPlayButton = ({ audioBegin, audioEnd, id }) => {
  const { isPlaying, playPause } = useInsightAudioPlayer(audioBegin, audioEnd, id);

  return (
    <IconButton sx={{ padding:"1px 6px 1px 2px"}} onClick={playPause} size="small">
      {isPlaying ? (
        <PauseAudioIcon />
      ) : (
        <PlayAudioIcon/>
      )}
    </IconButton>
  );
};

export default AudioPlayButton;